import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, MapPin } from "lucide-react";

export const CONSULT_CATS = ["3D PRINT", "3D SCAN"];
export const needsConsult = (...names) => names.some((n) => CONSULT_CATS.includes((n || "").toUpperCase()));

export const ConsultBox = ({ c, topic, compact }) => {
  const msg = encodeURIComponent(`Halo FOMU, saya mau konsultasi dengan tim konsultan 3D untuk ${topic}.`);
  return (
    <div className={`rounded-2xl border border-emerald-200 bg-emerald-50/70 ${compact ? "p-3" : "p-4 mb-4"}`} data-testid="pub-consult">
      <b className="text-sm text-emerald-900">Bingung pilih material atau ukuran?</b>
      <p className="text-xs text-emerald-800 mt-0.5">Konsultasi gratis dengan tim konsultan 3D kami lewat WhatsApp, atau datang langsung ke workshop.</p>
      <div className="flex flex-wrap gap-2 mt-3">
        {c?.wa && <a href={`https://wa.me/${c.wa}?text=${msg}`} target="_blank" rel="noreferrer" data-testid="pub-consult-wa" className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-emerald-600 text-white text-xs font-semibold hover:bg-emerald-700 transition-colors"><MessageCircle className="w-4 h-4" /> Konsultasi via WA</a>}
        <Link to="/booking" data-testid="pub-consult-visit" className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full border border-emerald-600 text-emerald-700 text-xs font-semibold bg-white hover:bg-emerald-50 transition-colors"><MapPin className="w-4 h-4" /> Kunjungan ke workshop</Link>
      </div>
      {c?.address && <p className="text-[11px] text-emerald-800/80 mt-2" data-testid="pub-consult-address">Workshop: {c.address}</p>}
    </div>
  );
};
